<template>
    <div class="navTab">
        <div class="navList" :class="{'ptop64': height === 'isIos', 'ptop88': height === 'isIos2', 'navR': isType == 'isType', 'ptop64_2': isTop == 'isTop64', 'ptop88_2': isTop == 'isTop88', 'ptop': isTop == 'more'}">
            <div class="nav" >
                <div class="navLi" :class="{'active': tab === 0}" @click="onTabNav(0)">
                    默认
                </div>
                <div class="navLi" :class="{'active': tab === 1}" @click="onTabNav(1)" v-if="parseInt(screenType) === 1">
                    最新
                </div>
                <div class="navLi" :class="{'active': tab === 1}" @click="onOpenBrands(1)" v-else>
                    品牌
                </div>
                <div class="navLi" :class="{'active': tab === 2}" @click="onTabNav(2)">
                    价格<span class="price" :class="{'active1': sortPrice === 1, 'active2': sortPrice === 2}"></span>
                </div>
                <div class="navLi" @click="onTriangle">
                    筛选<span class="select"></span>
                </div>
            </div>
            <div class="toggle" @click="onToggle">
                <div class="tg">
                    <div class="tg1" :class="{'tg2': toggle}"></div>
                </div>
            </div>
        </div>
        <div class="hTop" v-if="isType !== 'isType'" :class="{'hTop64': height === 'isIos', 'hTop88': height === 'isIos2'}"></div>
        <GoodsList ref="goods" :maxPrice='maxPrice' :minPrice='minPrice' :sortState='sortPrice'></GoodsList>
        <mt-popup v-model="popupVisible" position="right" class="mint-popup-3">
            <div class="side">
                <div class="sideUl">
                    <div class="screen" v-if="parseInt(screenType) !== 2">
                        <div class="h3">系统<span class="fPrice">{{ category.name }}</span></div>
                        <div class="ul">
                            <div class="li" :class="{'active': item.id === category.id}" v-for="(item, index) in tabSidle" v-show="index < 5" :key="item.id" @click="onTab(item)">
                                {{ item.name }}
                            </div>
                            <div class="li all arrow" @click="onSystem">
                                全部系统
                            </div>
                        </div>
                    </div>
                    <div class="screen" v-if="parseInt(screenType) === 0 || parseInt(screenType) === 2">
                        <div class="h3">品牌<span class="fPrice">{{ brandsName }}</span></div>
                        <div class="ul">
                            <div v-for="(item, index) in brands" :key="item.id" v-show="index < 5">
                                <div class="li" :class="{'active': item.isCheck}" @click="onBrandList(item)">
                                    {{ item.name }}
                                </div>
                            </div>
                            <div class="li all arrow" @click.capture.stop="onBrand">
                                全部品牌
                            </div>
                        </div>
                    </div>
                    <div class="screen">
                        <div class="h3">价格</div>
                        <div class="priceInput">
                            <div class="li">
                                <input type="number" placeholder="最低价" v-model="minPrice">
                            </div>
                            <div class="line">
                            </div>
                            <div class="li">
                                <input type="number" placeholder="最高价" v-model="maxPrice">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="foot">
                    <span @click="onReset">重置</span>
                    <span class="submit" @click="onSubmit">确定</span>
                </div>
            </div>
        </mt-popup>
        <mt-popup v-model="popupVisible3" position="right" class="mint-popup-2">
            <Header ref="header" @backPage="onBack1" title="全部系统"></Header>
            <div class="contarin">
                <div class="con-left" ref="left">
                    <div>
                        <div class="conLi" :class="{'active': tab1 === item.id}" v-for="(item, index) in tabSidle" :key="item.id" @click="onSys(item.id, index)">
                            {{ item.name }}
                        </div>
                    </div>
                </div>
                <div class="con-right" ref="right">
                    <div>
                        <div class="conLi borderBot" :class="{'active': category.id === item.id}" v-for="item in tabSidle1" :key="item.id" @click="onTab(item)">
                            {{ item.name }}
                        </div>
                    </div>
                </div>
            </div>
        </mt-popup>
        <mt-popup v-model="popupVisible2" position="right" class="mint-popup-1" :closeOnClickModal="false">
            <Header ref="header" title="全部品牌" @backPage="onBack1" :titleRight='titleRight2' @submit='brandSubmit'></Header>
            <div class="container">
                <mt-index-list>
                    <div>
                        <mt-index-section v-show="displayNone" index="#">
                        </mt-index-section>
                    </div>
                    <div v-for="item in getBrandsData" :key="item.id">
                        <mt-index-section :index="item.brandInitials" v-show="item.brandFalse">
                            <p class="" v-for="it in item.brandList" :key="it.id" :class="{'active': it.isCheck, 'borderBot': item.brandList.length > 1}" v-text="it.name" @click="onBrandClick(it)"></p>
                        </mt-index-section>
                    </div>
                </mt-index-list>
            </div>
        </mt-popup>
    </div>
</template>
<script>
import BScroll from 'better-scroll'
import Header from '../../../common/header'
import { mapActions } from 'vuex'
import GoodsList from './goods'
import { Modal } from '../../api/model.js'
export default {
    name: 'navTab',
    components: {
        Header,
        GoodsList
    },
    props: [ 'isType', 'isTop', 'screenType', 'categoryId', 'brandId' ],
    data () {
        return {
            userInfo: '',
            title: '',
            tab: 0,
            height: '',
            sortState: 0, // 价格排序 1 升序 2 降序
            tabSelect: true, // 价格选择
            maxPrice: '', // 价格最大值
            minPrice: '', // 价格最小值
            priceCopy: '',
            sortPrice: 0,
            faddish: '',
            categoryIds: this.categoryId,
            brandId2: this.brandId,
            toggle: false,
            titleRight: '筛选',
            popupVisible: false,
            popupVisible2: false,
            popupVisible3: false,
            tabSidle: [],
            tabSidle1: [],
            category: '', // 选中的系统对象
            categoryCopy: '',
            tab1: 0,
            brands: [],
            brandData: [],
            brandsList: [],
            brandActive: 0, // 品牌选中状态
            brandArray: [], // 选中商品数组
            brandIds: '', // 逗号分隔的品牌id字符串
            brandsName: '', // 逗号分隔的品牌名称字符串
            brandName: '',
            titleRight2: '确定',
            brandTab: false, // 判断是否点击品牌tab
            displayNone: false
        }
    },
    watch: {
        'popupVisible' (val) {
            if (!val) {
                Modal.beforeClose()
            } else {
                Modal.afterOpen()
            }
        }
    },
    computed: {
        getBrandsData () {
            return this.brandListYw(this.brandData)
        }
    },
    methods: {
        ...mapActions(['setBuried', 'findCategoryListData', 'getbrandListData']),
        onToggle () {
            this.toggle = !this.toggle
            this.$refs.goods.onToggle()
        },
        onBack1 () {
            this.popupVisible2 = false
            this.popupVisible3 = false
        },
        onBrandList (item) {
            item.isCheck = !item.isCheck
            let brands = this.brands
            let brandId = []
            let brandName = []
            brands.forEach(item => {
                if (item.isCheck) {
                    brandId.push(item.id)
                    brandName.push(item.name)
                }
            })
            this.brandIds = brandId.join(',')
            this.brandsName = brandName.join(',')
            this.$forceUpdate()
        },
        brandSubmit () {
            let brands = this.brandData
            let brandId = []
            let brandName = []
            brands.forEach(item => {
                if (item.isCheck) {
                    brandId.push(item.id)
                    brandName.push(item.name)
                }
            })
            this.brandIds = brandId.join(',')
            this.brandsName = brandName.join(',')
            this.brands = JSON.parse(JSON.stringify(this.brandData))
            this.popupVisible2 = false
            if (this.brandTab) {
                this.onSubmit()
            }
        },
        onBrandClick (item) {
            item.isCheck = !item.isCheck
            this.$forceUpdate()
        },
        onReset () {
            this.category = ''
            this.brandsName = ''
            let brand = this.brands
            let brands = this.getBrandsData
            brand.forEach(item => {
                item.isCheck = false
            })
            brands.forEach(item => {
                item.brandList.forEach(it => {
                    it.isCheck = false
                })
            })
            this.brandIds = ''
            this.maxPrice = ''
            this.minPrice = ''
        },
        onFaddish (faddish) {
            this.faddish = faddish == 1 ? faddish : ''
            this.onSubmit()
        },
        onGoods (obj) {
            this.categoryIds = obj.categoryId
            this.brandId2 = obj.brandId
            this.onSubmit()
        },
        onSubmit () {
            // 系统
            if (parseInt(this.screenType) !== 2) {
                this.categoryIds = this.category.id || ''
                this.categoryCopy = this.category
                this.title = this.category.name ? this.category.name : this.$route.query.name
            }
            // 品牌
            if (parseInt(this.screenType) !== 1) {
                this.brandId2 = this.brandIds
                this.brandName = this.brandsName
                this.brandsList = JSON.parse(JSON.stringify(this.brands))
                this.brandsListData = JSON.parse(JSON.stringify(this.getBrandsData))
            }
            // 价格
            let maxP = parseFloat(this.minPrice) > parseFloat(this.maxPrice) ? parseFloat(this.minPrice) : parseFloat(this.maxPrice)
            let minP = parseFloat(this.minPrice) > parseFloat(this.maxPrice) ? parseFloat(this.maxPrice) : parseFloat(this.minPrice)
            this.maxPrice = maxP || ''
            this.minPrice = minP || ''
            this.priceCopy = { 'minPrice': this.minPrice, 'maxPrice': this.maxPrice }
            this.popupVisible = false
            this.$refs.goods.onSubmit({
                faddish: this.faddish,
                categoryId: this.categoryIds,
                brandIds: this.brandId2,
                maxPrice: this.maxPrice,
                minPrice: this.minPrice,
                sortState: this.sortPrice
            })
        },
        onSystem () {
            this.popupVisible3 = true
        },
        onBrand () {
            this.popupVisible2 = true
            this.brandData = JSON.parse(JSON.stringify(this.brands))
            this.$forceUpdate()
        },
        onTriangle () {
            this.buryPoint(76)
            this.category = this.categoryCopy
            this.brandIds = this.brandId2
            this.brandsName = this.brandName
            if (this.brandsList.length) {
                this.brands = JSON.parse(JSON.stringify(this.brandsList))
            }
            this.minPrice = this.priceCopy.minPrice
            this.maxPrice = this.priceCopy.maxPrice
            this.popupVisible = true
        },
        onTab (obj) {
            this.category = obj
            this.popupVisible3 = false
        },
        onOpenBrands (a) {
            this.tab = a
            this.popupVisible2 = true
            this.brandTab = true
        },
        onTabNav (a) {
            this.tab = a
            if (a === 2) {
                this.tabSelect = !this.tabSelect
                this.sortPrice = this.tabSelect ? 2 : 1
            } else if (a === 1) {
                this.sortPrice = 0
            } else if (a === 0) {
                this.sortPrice = 0
            } else {
                this.tabSelect = true
            }
            this.$refs.goods.onSubmit({
                categoryId: this.categoryIds,
                faddish: this.faddish,
                brandIds: this.brandId2,
                maxPrice: this.maxPrice,
                minPrice: this.minPrice,
                sortState: this.sortPrice
            })
        },
        onSys (num, index) {
            this.tab1 = num
            this.tabSidle1 = this.tabSidle[index]['subCategoryList']
        },
        async getBrandsList () {
            await this.getbrandListData({
                status: 1,
                memberCode: this.userInfo.companyCode,
                merchantCode: this.userInfo.belongMerchantCode
            }).then((data) => {
                if (!data) {
                    return false
                }
                data.forEach(item => {
                    item.isCheck = false
                })
                this.brands = JSON.parse(JSON.stringify(data))
                this.brandData = data
            })
        },
        brandListYw (data) {
            let arr = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z']
            let brandArr = []
            for (let i = 0; i < arr.length; i++) {
                let arrData = []
                for (let j = 0; j < data.length; j++) {
                    if (arr[i] === data[j]['brandInitials']) {
                        arrData.push(data[j])
                    }
                }
                let obj = {
                    brandInitials: arr[i],
                    brandFalse: arrData.length,
                    brandList: arrData
                }
                brandArr.push(obj)
            }
            return brandArr
        },
        async getcategroyList () {
            await this.findCategoryListData({
                memberCode: this.userInfo.companyCode,
                merchantCode: this.userInfo.belongMerchantCode
            }).then((data) => {
                if (!data) {
                    return false
                }
                this.tabSidle = data
                this.$nextTick(() => {
                    this.tabSidle1 = data[0]['subCategoryList']
                    this.tab1 = data[0]['id']
                    this.left = new BScroll(this.$refs.left, {
                        click: true
                    })
                    this.right = new BScroll(this.$refs.right, {
                        click: true
                    })
                })
            })
        },
        buryPoint (event) {
            this.setBuried({ event: event })
        },
        init () {
            this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
            let iosHeight = localStorage.getItem('height')
            this.getBrandsList() // 获取品牌列表
            this.getcategroyList() // 获取类目列表
            if (parseInt(iosHeight) === 64) {
                this.height = 'isIos'
            } else if (parseInt(iosHeight) === 88) {
                this.height = 'isIos2'
            }
        }
    },
    mounted () {
        this.init()
    }
}
</script>
<style lang="scss" scoped>
.ptop {
    top: 200px !important;
}
.ptop64{
    top: 128px !important;
}
.ptop64_2{
    top: 250px !important;
}
.ptop88{
    top: 176px !important;
    padding-top: 0 !important;
}
.ptop88_2{
    top: 298px !important;
}
.navR{
    position: relative !important;
    top: 0 !important;
    z-index: 0 !important;
}
.hTop{
    height: 88px !important;
}
.navTab {
    position: relative;
    .navList{
        position: fixed;
        left: 0;
        right: 0;
        top: 88px;
        line-height: 88px;
        height: 88px;
        background: #ffffff;
        z-index: 999;
        // border-top: 2px solid #EEEEEE;
    }
    .nav {
        display: flex;
        justify-content: space-around;
        text-align: center;
        margin-right: 94px;
        font-size: 28px;
        color: #666666;
        .navLi {
            flex: 25%;
            position: relative;
            span{
                width: 32px;
                height: 32px;
                display: inline-block;
                &.price{
                    background: url(../../../../assets/img/b2b/icon_arrowsmr@2x.png) no-repeat;
                    background-size: 100% 100%;
                    vertical-align: sub;
                }
                &.active1 {
                    background: url(../../../../assets/img/b2b/icon_arrowsup@2x.png) no-repeat;
                    background-size: 100% 100%;
                    vertical-align: sub;
                }
                &.active2 {
                    background: url(../../../../assets/img/b2b/icon_arrowsdown@2x.png) no-repeat;
                    background-size: 100% 100%;
                    vertical-align: sub;
                }
                &.select{
                    background: url(../../../../assets/img/b2b/icon_shaixuan@2x.png) no-repeat;
                    background-size: 100% 100%;
                    vertical-align: sub;
                }
            }
            &.active {
                color: #ff7a45;
            }
        }
    }
    .toggle{
        position: absolute;
        right: 0;
        top: 0;
        width: 94px;
        height: 88px;
        .tg{
            width: 32px;
            height: 32px;
            display: flex;
            margin-top: 28px;
            padding-left: 30px;
            border-left: 2px solid #D1D1D6;
            .tg1{
                width: 32px;
                height: 32px;
                background: url(../../../../assets/img/b2b/icon_list1@2x.png) no-repeat;
                background-size: 100% 100%;
            }
            .tg2{
                width: 32px;
                height: 32px;
                background: url(../../../../assets/img/b2b/icon_list2@2x.png) no-repeat;
                background-size: 100% 100%;
            }
        }
    }
    .side {
        height: calc(100% - 150px);
        overflow: auto;
        .sideUl {
            padding: 0 20px;
            .screen {
                margin-top: 60px;
            }
            .h3 {
                margin-bottom: 40px;
                color: #333333;
                font-size: 28px;
                .fPrice {
                    float: right;
                    font-size: 24px;
                    color: #ff7a45;
                    width: 6rem;
                    text-align: right;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 1;
                    overflow: hidden;
                    white-space: normal;
                    word-break: break-all;
                }
            }
            .priceInput{
                display: flex;
                justify-content: space-between;
                .li{
                    width: 224px;
                    height: 80px;
                    line-height: 80px;
                    border-radius: 80px;
                    background: #F4F4F4;
                }
                .line{
                    width: 40px;
                    height: 2px;
                    margin-top: 40px;
                    background: #999999;
                }
                input{
                    font-size: 24px;
                    text-align: center;
                    background: none;
                }
            }
            .ul {
                display: flex;
                flex-wrap: wrap;
                justify-content: space-between;
                .li {
                    width: 170px;
                    height: 88px;
                    text-align: center;
                    line-height: 88px;
                    background: #f5f5f5;
                    color: #333;
                    font-size: 24px;
                    margin-bottom: 16px;
                    border-radius: 4px;
                    border: 2px solid #ffffff;
                    position: relative;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 1;
                    overflow: hidden;
                    white-space: normal;
                    word-break: break-all;
                }
                .all {
                    background: none;
                }
                .active {
                    background: #ffeae1;
                    color: #ff7a45;
                    border: 2px solid rgba(255, 122, 69, 1);
                }
            }
        }
        .foot {
            position: absolute;
            bottom: 40px;
            right: 16px;
            span {
                display: inline-block;
                font-size: 28px;
                margin-left: 24px;
                width: 208px;
                height: 64px;
                line-height: 64px;
                border-radius: 64px;
                text-align: center;
                border: 2px solid #ff7a45;
                color: #ff7a45;
            }
            .submit {
                background: #ff7a45;
                color: #ffffff;
            }
        }
        .sideActive {
            right: 0;
        }
    }
    .contarin {
        height: calc(100% - 150px);
        display: flex;
        justify-content: flex-start;
        // margin-top: 88px;
        overflow: hidden;
        .conLi {
            position: relative;
            height: 88px;
            line-height: 88px;
            padding-left: 32px;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
            overflow: hidden;
        }
        .con-left {
            flex: 0 0 236px;
            .active {
                background: #ffffff;
                color: #ff7a45;
                position: relative;
                &::before {
                    content: "";
                    position: absolute;
                    left: 0;
                    top: 20px;
                    background: url(../../../../assets/img/b2b/left_icon.png)
                        no-repeat;
                    background-size: 100% 100%;
                    width: 6px;
                    height: 40px;
                }
            }
        }
        .con-right {
            width: 100%;
            height: 100%;
            background: #ffffff;
            .active {
                color: #ff7a45;
                position: relative;
                &::after {
                    content: "";
                    position: absolute;
                    right: 28px;
                    top: 24px;
                    background: url(../../../../assets/img/b2b/icon_select@2x.png)
                        no-repeat;
                    background-size: 100% 100%;
                    width: 40px;
                    height: 40px;
                }
            }
        }
    }
}
.mint-popup-1 {
    width: 100%;
    height: 100%;
    background-color: #f5f5f5;
}
.mint-popup-2 {
    width: 100%;
    height: 100%;
    background-color: #f5f5f5;
}
.mint-popup-3 {
    width: 80%;
    height: 100%;
    background-color: #fff;
}
.mint-popup-right {
    -webkit-transform: translate3d(0, -50.1%, 0);
    transform: translate3d(0, -50.1%, 0);
}
.arrow:after {
    top: 25px;
}
/deep/ .mint-indexlist-content {
    margin-right: 0 !important;
    overflow: auto;
    -webkit-overflow-scrolling: touch;
    overflow-scrolling: touch;
}
/deep/ .mint-indexsection-index {
    font-size: 26px;
    color: #8e8e93;
    height: 36px;
    line-height: 36px;
    padding: 20px 32px 10px;
    background: none;
}
/deep/ .mint-indexsection-index + ul {
    background: #ffffff;
    overflow: hidden;
    .active {
        color: #ff7a45;
        position: relative;
        &::after {
            content: "";
            position: absolute;
            right: 28px;
            top: 34px;
            background: url(../../../../assets/img/b2b/icon_select@2x.png)
                no-repeat;
            background-size: 100% 100%;
            width: 40px;
            height: 40px;
        }
    }
}
/deep/ .mint-indexsection-index + ul p {
    font-size: 28px;
    padding: 32px;
    color: #000000;
    position: relative;
}
/deep/ .mint-indexlist-navitem {
    font-size: 22px;
    color: #007aff;
}
/deep/ .mint-indexlist-nav {
    position: fixed;
    background: none;
    border: none;
}
</style>